import { render, staticRenderFns } from "./slideshow.vue?vue&type=template&id=e8468164&scoped=true"
import script from "./slideshow.vue?vue&type=script&lang=js"
export * from "./slideshow.vue?vue&type=script&lang=js"
import style0 from "./slideshow.vue?vue&type=style&index=0&id=e8468164&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8468164",
  null
  
)

export default component.exports